import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { formatPriceWithoutCurrency } from '../../helpers';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../partials/custom_date_picker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReportTabs from './report_tabs';

const KpiCard = ({ label, value, icon, color = '#00C6FE', sub }) => (
    <div className="bg-gray-2 p-3 d-flex flex-column" style={{ borderRadius: 8, minWidth: 140, borderLeft: `3px solid ${color}` }}>
        <div className="d-flex align-items-center justify-content-between mb-1">
            <span className="gray font-10 poppins">{label}</span>
            {icon && <i className={`${icon} font-12`} style={{ color }} />}
        </div>
        <span className="white poppins toBold" style={{ fontSize: '1.7rem', lineHeight: 1 }}>{value}</span>
        {sub && <span className="font-10 mt-1 poppins" style={{ color }}>{sub}</span>}
    </div>
);

const PAGE_SIZE = 30;

class Transactions extends React.Component {
    state = {
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        day: moment(),
        search: '',
        page: 0,
        filterType: 'all',    // 'all' | 'credit' | 'debit'
        filterPaymentId: null,
        filterStaffId: null,
        pickPayment: false,
        pickStaff: false,
        pickType: false,
        pickDate: false,
    }

    componentWillMount() {
        this.props.logic_actions?.fetch_conversion_rates();
        const { id } = this.props.params;
        if (id) {
            let me = fakeAuth.getUser();
            this.props.staffs_actions && this.props.staffs_actions.fetch(me.IdAccount);
        }
    }

    componentWillReceiveProps = nextProps => {
        const { staffs } = nextProps;
        if (staffs) this.setState({ staffs });
        if (nextProps.report_entries && this.state.microTransac) {
            this.setState({ microTransac: false });
        }
    }

    onFetch = () => {
        this.setState({ microTransac: true, page: 0 }, () => {
            this.props.logic_actions && this.props.logic_actions.fecth_close_report({
                IdProperty: this.props.params.id,
                Day: this.state.day.format('YYYY-MM-DD'),
            });
        });
    }

    getFiltered = () => {
        const { report_entries } = this.props;
        const { filterType, filterPaymentId, filterStaffId, search } = this.state;
        if (!report_entries) return [];

        return _.chain(report_entries)
            .filter(t => {
                if (filterType === 'credit') return parseFloat(t.Credit) > 0;
                if (filterType === 'debit') return parseFloat(t.Debit) > 0;
                return true;
            })
            .filter(t => filterPaymentId ? t.IdPaymentType === filterPaymentId : true)
            .filter(t => filterStaffId ? t.IdUser === filterStaffId : true)
            .filter(t => {
                if (!search) return true;
                return JSON.stringify(t).toLowerCase().includes(search.toLowerCase());
            })
            .sortBy(t => t.CreateDate)
            .value();
    }

    renderHeader = () => (
        <div className="d-flex">
            <div className="w-100 d-flex">
                <i className="icon-lb_reportes blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Reportes</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    )

    renderKpis = () => {
        const { report_entries } = this.props;
        if (!report_entries || !report_entries.length) return null;

        const filtered = this.getFiltered();
        const totalCredit = _.sum(filtered.map(t => parseFloat(t.Credit) || 0));
        const totalDebit = _.sum(filtered.map(t => parseFloat(t.Debit) || 0));
        const balance = totalCredit - totalDebit;

        return (
            <div className="d-flex flex-wrap mb-3" style={{ gap: 10 }}>
                <KpiCard label="Total créditos" value={`USD ${totalCredit.toFixed(2)}`} icon="fas fa-arrow-down" color="#00c97a" />
                <KpiCard label="Total débitos" value={`USD ${totalDebit.toFixed(2)}`} icon="fas fa-arrow-up" color="#FF6B6B" />
                <KpiCard label="Balance" value={`USD ${balance.toFixed(2)}`} icon="fas fa-balance-scale"
                    color={balance >= 0 ? '#00c97a' : '#FF6B6B'} />
                <KpiCard label="Transacciones" value={filtered.length} icon="fas fa-list" color="#00C6FE" />
            </div>
        );
    }

    renderFilters = () => {
        const { day, filterType, filterPaymentId, filterStaffId, staffs = [] } = this.state;
        const selectedPayment = _.find(config.payment_types, pt => pt.id === filterPaymentId);
        const selectedStaff = _.find(staffs, s => s.IdUser === filterStaffId);
        const typeLabels = { all: 'Todos', credit: 'Créditos', debit: 'Débitos' };

        return (
            <Animated animationIn="fadeInDown" animationInDuration={200} className="d-flex flex-wrap align-items-flex-end mb-3" style={{ gap: 10 }}>

                {/* Date */}
                <div style={{ minWidth: 150 }}>
                    <label className="white poppins font-11 d-block mb-1">Fecha</label>
                    <DatePicker
                        selected={day}
                        customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Fecha" />}
                        showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                        maxDate={moment()}
                        onChange={date => this.setState({ day: moment(date) })}
                    />
                </div>

                {/* Type: credit / debit / all */}
                <div style={{ minWidth: 150 }}>
                    <label className="white poppins font-11 d-block mb-1">Tipo</label>
                    <div className="black-input d-flex">
                        <Dropdown isOpen={this.state.pickType} toggle={() => this.setState({ pickType: !this.state.pickType })} className="w-100">
                            <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                <span className="align-self-center font-12">{typeLabels[filterType]}</span>
                                <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                            </DropdownToggle>
                            <DropdownMenu className="w-100">
                                {Object.entries(typeLabels).map(([k, v]) => (
                                    <DropdownItem key={k} onClick={() => this.setState({ filterType: k, page: 0, pickType: false })}>{v}</DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>

                {/* Payment type */}
                <div style={{ minWidth: 190 }}>
                    <label className="white poppins font-11 d-block mb-1">Forma de pago</label>
                    <div className="black-input d-flex">
                        <Dropdown isOpen={this.state.pickPayment} toggle={() => this.setState({ pickPayment: !this.state.pickPayment })} className="w-100">
                            <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                <span className="align-self-center font-12">{selectedPayment ? selectedPayment.name : 'Todas'}</span>
                                <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                            </DropdownToggle>
                            <DropdownMenu className="w-100" style={{ maxHeight: 260, overflowY: 'auto' }}>
                                <DropdownItem onClick={() => this.setState({ filterPaymentId: null, page: 0, pickPayment: false })}>Todas</DropdownItem>
                                {config.payment_types.map((pt, i) => (
                                    <DropdownItem key={i} onClick={() => this.setState({ filterPaymentId: pt.id, page: 0, pickPayment: false })}>{pt.name}</DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>

                {/* Staff */}
                {staffs.length > 0 && (
                    <div style={{ minWidth: 180 }}>
                        <label className="white poppins font-11 d-block mb-1">Empleado</label>
                        <div className="black-input d-flex">
                            <Dropdown isOpen={this.state.pickStaff} toggle={() => this.setState({ pickStaff: !this.state.pickStaff })} className="w-100">
                                <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                    <span className="align-self-center font-12">
                                        {selectedStaff ? `${selectedStaff.FirstName} ${selectedStaff.LastName}` : 'Todos'}
                                    </span>
                                    <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                                </DropdownToggle>
                                <DropdownMenu className="w-100" style={{ maxHeight: 260, overflowY: 'auto' }}>
                                    <DropdownItem onClick={() => this.setState({ filterStaffId: null, page: 0, pickStaff: false })}>Todos</DropdownItem>
                                    {_.sortBy(staffs, 'FirstName').map((s, i) => (
                                        <DropdownItem key={i} onClick={() => this.setState({ filterStaffId: s.IdUser, page: 0, pickStaff: false })}>
                                            {s.FirstName} {s.LastName}
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                )}

                {/* Search */}
                <div style={{ minWidth: 200, flex: 1 }}>
                    <label className="white poppins font-11 d-block mb-1">Buscar</label>
                    <div className="bg-gray-2 black-input d-flex">
                        <i className="fas fa-search font-14 white align-self-center ps-3" />
                        <input className="w-100 p-3 white font-12" type="text" placeholder="Cliente, concepto, recibo..."
                            onChange={e => this.setState({ search: e.target.value, page: 0 })} />
                    </div>
                </div>

                {/* Actions */}
                <div className="d-flex align-items-flex-end" style={{ gap: 6, alignSelf: 'flex-end' }}>
                    <button onClick={this.onFetch} className="btn btn-blue white d-flex align-items-center px-3" style={{ height: 46 }}>
                        <i className="fas fa-search font-14 me-2" />
                        <span className="poppins font-12">Buscar</span>
                    </button>
                    {this.props.report_entries?.length > 0 && (
                        <ReactHTMLTableToExcel
                            id="trx-xls"
                            className="btn btn-link white bordered d-flex align-items-center px-3"
                            style={{ height: 46 }}
                            table="trx-table-xls"
                            filename="Transacciones"
                            sheet="Transacciones"
                            buttonText={<><i className="fas fa-file-excel font-14 me-2" /><span className="poppins font-12">Exportar</span></>}
                        />
                    )}
                </div>
            </Animated>
        );
    }

    renderTable = () => {
        const { page } = this.state;
        const { staffs = [] } = this.state;
        const filtered = this.getFiltered();
        const total_pages = Math.ceil(filtered.length / PAGE_SIZE);
        const page_data = filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

        const getPaymentName = (id) => (_.find(config.payment_types, pt => pt.id === id) || {}).name || '-';
        const getStaffName = (id) => {
            const s = _.find(staffs, u => u.IdUser === id);
            return s ? `${s.FirstName} ${s.LastName}` : '-';
        };

        const thead = (
            <thead>
                <tr>
                    <th>#</th>
                    <th>Fecha</th>
                    <th>Recibo</th>
                    <th>Cliente</th>
                    <th>Concepto</th>
                    <th>Empleado</th>
                    <th>Forma de pago</th>
                    <th>Tipo</th>
                    <th className="text-right">Crédito</th>
                    <th className="text-right">Débito</th>
                </tr>
            </thead>
        );

        const renderRow = (t, i) => {
            const isCredit = parseFloat(t.Credit) > 0;
            return (
                <tr key={i}>
                    <td className="gray">{page * PAGE_SIZE + i + 1}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{moment(t.CreateDate).format('DD/MM/YYYY HH:mm')}</td>
                    <td>{t.Confirmation}</td>
                    <td>{t.GivenName}</td>
                    <td>{t.Reason}</td>
                    <td>{getStaffName(t.IdUser)}</td>
                    <td>{getPaymentName(t.IdPaymentType)}</td>
                    <td>
                        <span style={{
                            display: 'inline-block', borderRadius: 4, padding: '1px 7px', fontSize: '0.75em',
                            background: isCredit ? '#00c97a22' : '#FF6B6B22',
                            color: isCredit ? '#00c97a' : '#FF6B6B',
                        }}>
                            {isCredit ? 'Crédito' : 'Débito'}
                        </span>
                    </td>
                    <td className="text-right" style={{ color: '#00c97a' }}>
                        {parseFloat(t.Credit) > 0 ? formatPriceWithoutCurrency(parseFloat(t.Credit) * 100) : '-'}
                    </td>
                    <td className="text-right" style={{ color: '#FF6B6B' }}>
                        {parseFloat(t.Debit) > 0 ? formatPriceWithoutCurrency(parseFloat(t.Debit) * 100) : '-'}
                    </td>
                </tr>
            );
        };

        const totalCredit = _.sum(filtered.map(t => parseFloat(t.Credit) || 0));
        const totalDebit = _.sum(filtered.map(t => parseFloat(t.Debit) || 0));

        return (
            <div>
                {/* Hidden full table for Excel */}
                <table className="table font-10" id="trx-table-xls" style={{ display: 'none' }}>
                    {thead}
                    <tbody>{filtered.map((t, i) => renderRow(t, i))}</tbody>
                </table>

                {/* Visible paginated table */}
                <table className="table font-10">
                    {thead}
                    <tbody>
                        {page_data.length === 0 && (
                            <tr><td colSpan={10} className="text-center gray poppins py-4">No se encontraron transacciones con los filtros seleccionados.</td></tr>
                        )}
                        {page_data.map((t, i) => renderRow(t, i))}
                    </tbody>
                    <tfoot>
                        <tr style={{ borderTop: '2px solid #555' }}>
                            <td colSpan={8} className="text-right poppins font-10 gray">Totales ({filtered.length} transacciones)</td>
                            <td className="text-right poppins toBold font-10" style={{ color: '#00c97a' }}>{totalCredit.toFixed(2)}</td>
                            <td className="text-right poppins toBold font-10" style={{ color: '#FF6B6B' }}>{totalDebit.toFixed(2)}</td>
                        </tr>
                    </tfoot>
                </table>

                {total_pages > 1 && (
                    <div className="d-flex justify-content-center align-items-center mt-2 mb-2" style={{ gap: 6 }}>
                        <button className="btn btn-link poppins font-12" style={{ color: page === 0 ? '#444' : '#008db5' }}
                            disabled={page === 0} onClick={() => this.setState({ page: 0 })}>
                            <i className="fas fa-angle-double-left" />
                        </button>
                        <button className="btn btn-link poppins font-12" style={{ color: page === 0 ? '#444' : '#008db5' }}
                            disabled={page === 0} onClick={() => this.setState({ page: page - 1 })}>
                            <i className="fas fa-angle-left" />
                        </button>
                        {_.range(total_pages).map(p => (
                            <button key={p} className="btn btn-link poppins font-12"
                                style={{ color: p === page ? '#fff' : '#555', fontWeight: p === page ? 700 : 400, minWidth: 28 }}
                                onClick={() => this.setState({ page: p })}>{p + 1}</button>
                        ))}
                        <button className="btn btn-link poppins font-12" style={{ color: page >= total_pages - 1 ? '#444' : '#008db5' }}
                            disabled={page >= total_pages - 1} onClick={() => this.setState({ page: page + 1 })}>
                            <i className="fas fa-angle-right" />
                        </button>
                        <button className="btn btn-link poppins font-12" style={{ color: page >= total_pages - 1 ? '#444' : '#008db5' }}
                            disabled={page >= total_pages - 1} onClick={() => this.setState({ page: total_pages - 1 })}>
                            <i className="fas fa-angle-double-right" />
                        </button>
                        <span className="poppins font-10 ms-2 gray">
                            {page * PAGE_SIZE + 1}–{Math.min((page + 1) * PAGE_SIZE, filtered.length)} de {filtered.length}
                        </span>
                    </div>
                )}
            </div>
        );
    }

    renderCommon = () => {
        const { params } = this.props;
        const hasData = this.props.report_entries && this.props.report_entries.length > 0;

        return (
            <div>
                {this.renderHeader()}
                <ReportTabs active="transactions" id={params.id} />

                <div style={{ position: 'absolute', top: '11em', bottom: 0, left: 100, right: 0, display: 'flex', flexDirection: 'column' }} className="bg-gray-dark">

                    {/* Top zone: filters — no overflow so dropdowns show */}
                    <div className="px-3 pt-3" style={{ flexShrink: 0, position: 'relative', zIndex: 200 }}>
                        {this.renderFilters()}
                    </div>

                    {/* Bottom zone: scrollable */}
                    <div style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }} className="px-3 pb-3">
                        {hasData && this.renderKpis()}

                        {hasData && (
                            <Animated animationIn="fadeInUp" animationInDuration={200}>
                                <div className="bg-gray-2 p-3 mt-2" style={{ borderRadius: 6, width: '100%' }}>
                                    <div className="d-flex align-items-center mb-2">
                                        <span className="white poppins font-12 toBold">
                                            {this.state.day.locale('es').format('dddd D [de] MMMM [de] YYYY')}
                                        </span>
                                    </div>
                                    {this.renderTable()}
                                </div>
                            </Animated>
                        )}

                        {!hasData && !this.state.microTransac && (
                            <div className="d-flex flex-column justify-content-center align-items-center mt-5">
                                <i className="fas fa-exchange-alt font-40 gray mb-3" />
                                <span className="gray poppins font-14 text-center">Selecciona una fecha y haz clic en Buscar<br />para ver las transacciones del día.</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>
                    {this.state.microTransac && <LineLoader />}

                    <div className="w3-container w3-hide-small" style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>

                    <Menu {...this.state} {...this.props} />
                </section>
            </Layout>
        );
    }
}

export default Transactions;
